import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import Parser from "html-react-parser";

function CarouselComponent(props) {
  // Declare a new state variable, which we'll call "count"
  const [show, setShow] = useState(false);

  const [selectedTabId, setSelectedTabId] = useState(0);

  const { data } = props;
  const carosuelKey = crypto.randomUUID();

  console.log(data);

  return (
    <>
      <Container>
        <Row>
          <Col>
            {data.title && <strong>{data.title}</strong>}
            {data.body && Parser(data.body)}

            {data.images && (
              <Carousel
                interval={null}
                className="text-center"
                key={`carosuel-${selectedTabId}-${carosuelKey}`}
              >
                {data.images.map((image, i) => {
                  return (
                    <Carousel.Item
                      key={`carosuel-${i}-${selectedTabId}-${carosuelKey}`}
                    >
                      <img src={image} className="img-fluid" alt="" />{" "}
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CarouselComponent;
